import { render } from "./Nav.vue?vue&type=template&id=88fea75e"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"
script.render = render

export default script